import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
//import CardMedia from '@material-ui/core/CardMedia';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';

import Copyright from '../components/Copyright'

import authApi from '../api/auth';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  appBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  toolbar: {
    flexWrap: 'wrap',
  },
  toolbarTitle: {
    flexGrow: 1,
  },
  link: {
    margin: theme.spacing(1, 1.5),
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  footer: {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(8),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
    },
    root: {
      maxWidth: 345,
    },
    media: {
      height: 0,
      width: '100%',
      paddingTop: '56.25%',
    },
  },
}));

const Main = (props) => {
  const classes = useStyles();
  const {
    signInHandler
  } = props;


  const logOutHandler = async () => {
    try {
      await authApi.logOut();
      signInHandler(false);
    } catch(error) {
      signInHandler(false);
    }
  }
  

  return (
    <>
      <CssBaseline />

      <AppBar position="static" color="default" elevation={0} className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" color="inherit" noWrap className={classes.toolbarTitle}>
            BeWo Education
          </Typography>
          <Button
            onClick={logOutHandler}
            color="primary" 
            variant="outlined" 
            className={classes.link}>
            Cerrar Sesión
          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" component="main">
        <Grid container spacing={5} alignItems="center">
            <Grid item xs={12}>
              <br />
              <br />
              <Card >
                <CardHeader
                  title='Aventuras Emocionantes'
                  titleTypographyProps={{ align: 'center' }}
                  subheaderTypographyProps={{ align: 'center' }}
                  className={classes.cardHeader}
                />
                <img width='100%' src="/img/games/acceso_disponible.png" alt="Aventuras Emocionantes" />
                <CardActions>
                  <Button 
                    fullWidth 
                    variant='contained'
                    color="primary"
                    href="https://bewogames.com/games/aventuras-emocionantes/"
                    >
                    Jugar
                  </Button>
                  <Button 
                    fullWidth 
                    variant='contained'
                    color="primary"
                    href="https://drive.google.com/drive/folders/10zhDkqdsWtOViBTRApdGnoR1qB6SNWlC?usp=sharing"
                    target="_blank"
                    rel="noopener"
                    >
                    Extras Kit Educativo
                  </Button>
                </CardActions>
              </Card>
            </Grid>
        </Grid>
      </Container>


      <Container component="footer" className={classes.footer}>
        <Box mt={5}>
          <Copyright />
        </Box>
      </Container>
    </>
  );
}

export default Main;